/** @format */

import { JsonServiceClient } from "@servicestack/client";
import {
  AssignRole,
  UnAssignRole,
  CreateUser,
  DeleteUser,
  CreateOrUpdateClient,
  CreatePostRetirementClient,
  GetProjection,
  GetRiskNeed,
  GetRiskAbility,
  GetGoalRiskProfile,
  GetIncomeCashFlowResponse,
  GetContributionCashFlowResponse,
  GoalInfo,
  CreateOrUpdateCustomPortfolio,
  CalculateCustomPortfolioStats,
  CalculateCustomPortfolioStatsResponse,
  SaveProjection,
} from "@/dtos";
import {
  Authenticate,
  SessionInfo,
  GetUserInfo,
  ConvertSessionToToken,
} from "@/authdtos";
//import { request } from "express";

const isDev = false;
//console.log(location.host);
export const BaseUrl ="https://api.questlink.app/"; //"http://localhost:58306/";////"http://localhost:58306/";//  // "https://api.portfoliolink.co.za/"; //   "http://localhost:58306/"; //        //  ////"http://localhost:58306/"; // // //   //"https://api.portfoliolink.co.za/"; //  // "http://localhost:58306/"; // //
// // // ;
export const ProposalUrl = "https://plans.questlink.app/"; //
// ;
// "https://portfoliolinkapi.azurewebsites.net/"; // "";  //
//?
// : "portfoliolinkuat.azurewebsites.net; // .NET Core App Server on Azure

export const client = new JsonServiceClient(BaseUrl);
/*
    "withCredentials indicates whether or not cross-site Access-Control requests should be made using credentials"
    */
//client.credentials = "omit";

export const getSessionInfo = async () => {
  try {
    // Converts Session to JWT Token Cookie

    const authResponse = await client.get(new SessionInfo());

    // console.log("getSessionInfo", authResponse);
    return authResponse;
  } catch (e) {
    return null;
  }
};

export const logout = async () => {
  localStorage.removeItem("ss-tok");
  const request = new Authenticate();
  request.provider = "logout";
  // await getSessionInfo();
  await client.post(request);

  return "/";
};

export const login = async (provider, userName, password) => {
  await logout();

  const request = new Authenticate();
  request.provider = provider;
  request.userName = userName;
  request.password = password;

  request.useTokenCookie = true;

  var result = await client.post(request);

  client.bearerToken = result.bearerToken;

  localStorage.setItem("ss-tok", result.bearerToken);
  await getSessionInfo();

  return `/`;
};

export const getUserInfo = async (username) => {
  const request = new GetUserInfo();
  request.userName = username;
  return await client.get(request);
};

export const getSelectedPartner = async () => {
  const response = await client.get("/user/selectedpartner");
  return response;
};

export const changePartner = async (params) => {
  const response = await client.get("/user/changepartner", params);
  return response;
};

export const downloadProposalPlan = async (params) => {
  const response = await client.get("/v2/client/proposals/download", params);
  return response;
};

export const getWelcomeTour = async (params) => {
  const response = await client.get("/welcome", params);
  return response;
};
export const endWelcomeTour = async (params) => {
  const response = await client.get("/welcome/end", params);
  return response;
};

export const searchClients = async (params) => {
  const response = await client.get("/clients", params);
  return response;
};

export const getClient = async (params) => {
  const response = await client.get("/clients/" + params.id, params);
  return response;
};

export const createClient = async (params) => {
  let request = new CreateOrUpdateClient();
  request.clientView = params.clientView;
  const response = await client.post(request);
  return response;
};

export const createPostRetirementClient = async (params) => {
  let request = new CreatePostRetirementClient();
  request.clientView = params.clientView;
  request.currentSavings = params.currentSavings;

  request.desiredIncome = params.desiredIncome;
  const response = await client.post(request);
  return response;
};

export const assignRole = async (params) => {
  let request = new AssignRole();
  request.userName = params.userName;
  request.role = params.role;
  request.permission = params.permission;
  const response = await client.post(request);
  return response;
};

export const unAssignRole = async (params) => {
  let request = new UnAssignRole();
  request.userName = params.userName;
  request.role = params.role;
  request.permission = params.permission;
  const response = await client.post(request);
  return response;
};

export const unassignAllPermissions = async (params) => {
  const response = await client.postToUrl("/users/unassignallpermissions", {
    userName: params.userName,
  });
  return response;
};

export const getRetirementGoal = async (params) => {
  const response = await client.get("/goals/retirement/" + params.id);
  return response;
};
export const getClientGoals = async (params) => {
  const response = await client.get("/client/goals/", params);
  return response;
};

export const getPortfolios = async (params) => {
  const response = await client.get("/portfolios", params);
  return response;
};
export const calculatePortfolioAa = async (params) => {
  const response = await client.get("/calculator/aa", params);
  return response;
};
export const calculatePostRetirement = async (params) => {
  const response = await client.get("/calculator/postretirement", params);
  return response;
};
export const calculateOptimalPortfolio = async (params) => {
  const response = await client.get("/calculator/optimalportfolio", params);
  return response;
};
export const getPartnerSettings = async (params) => {
  const response = await client.get("/settings", params);
  return response;
};
export const getProposals = async (params) => {
  const response = await client.get("/proposals", params);
  return response;
};
export const updatePartnerSettings = async (params) => {
  const response = await client.get("/settings/update", params);
  return response;
};

export const updatePartnerDefaultSettings = async (params) => {
  const response = await client.postToUrl("/settings/default/update", params);
  return response;
};

export const getProposalAudit = async (params) => {
  const response = await client.get("/v2/partner/proposals/audit", params);
  return response;
};

export const sendSignatureRequest = async (params) => {
  const response = await client.get("/signing/sendrequest", params);
  return response;
};

export const generateReport = async (params) => {
  const response = await client.get("/pdf/generate", params);
  return response;
};
export const downloadFile = async (params) => {
  const response = await client.get("/pdf/download", params);
  return response;
};
export const downloadStream = async (params) => {
  const response = await client.get("/pdf/downloadstream", params);
  return response;
};
export const getPortfoliosGivenRisk = async (params) => {
  const response = await client.get("/riskprofiles/portfolios", params);
  return response;
};

export const getRiskProfiles = async (params) => {
  const response = await client.get("/riskprofiles", params);
  return response;
};
export const getTaxInfo = async (params) => {
  const response = await client.get("/tax", params);
  return response;
};

export const getRaTaxInfo = async (params) => {
  const response = await client.get("/tax/ra", params);
  return response;
};

export const getFeesInfo = async (params) => {
  const response = await client.get("/fees", params);
  return response;
};

export const getPartnerFees = async (params) => {
  const response = await client.get("/fees/partner", params);
  return response;
};

export const savePartnerFees = async (params) => {
  const response = await client.postToUrl("/fees/partner/save", {
    id: params.id,
    feeTable: { bracket: params.feeBrackets },
  });
  return response;
};

export const getPortfolioFees = async (params) => {
  const response = await client.get("/fees/partner/portfolio", params);
  return response;
};

export const savePortfolioFees = async (params) => {
  const response = await client.postToUrl("/fees/partner/portfolio/save", {
    portfolioId: params.portfolioId,
    feeTable: { bracket: params.feeBrackets },
  });
  return response;
};

export const updatePlanStatus = async (params) => {
  const response = await client.get("/goals/results/status", params);
  return response;
};

export const sendFeedback = async (params) => {
  const response = await client.postToUrl("/feedback", {
    message: params.message,
  });
  return response;
};

export const getUserMessages = async (params) => {
  const response = await client.get("/messages", params);
  return response;
};
export const getUserSignature = async (params) => {
  const response = await client.get("/user/signature", params);
  return response;
};
export const updateUser = async (params) => {
  const response = await client.get("/users/update", params);
  return response;
};

export const updateUserPassword = async (params) => {
  const response = await client.get("/user/management/password", params);
  return response;
};

export const getIncomeCashFlowRequest = async (params) => {
  const response = await client.get("/projections/income", params);
  return response;
};

export const additionalGetIncomeCashFlowRequest = async (params) => {
  const response = await client.postToUrl("/projections/additionalincome", {
    additionalGetIncomeCashFlowRequests:
      params.additionalGetIncomeCashFlowRequests,
  });
  return response;
};

export const additionalGetContributionCashFlowRequest = async (params) => {
  const response = await client.postToUrl(
    "/projections/additionalcontribution",
    {
      additionalGetContributionCashFlowRequests:
        params.additionalGetContributionCashFlowRequests,
    }
  );
  return response;
};

export const getCustomPortfolios = async (params) => {
  const response = await client.get("/customportfolios", params);
  return response;
};
export const getCustomPortfolio = async (params) => {
  const response = await client.get("/customportfolios/edit/", params);
  return response;
};
export const getContribution = async (params) => {
  const response = await client.get("/projections/contribution", params);
  return response;
};

export const getPartnerCapitalMarketAssumptions = async (params) => {
  const response = await client.get("/projections/capm", params);
  return response;
};

export const calculateCustomPortfolioStats = async (params) => {
  let request = new CalculateCustomPortfolioStats();
  request.customPortfolio = params.customPortfolio;

  request.loadUnderlyingData = params.loadUnderlyingData;
  request.loadUnderlyingType = params.loadUnderlyingType;
  if (params.id != -1) request.id = params.id;
  request.currency = params.currency;
  const response = await client.post(request);
  return response;
};

export const createOrUpdateCustomPortfolio = async (params) => {
  let request = new CreateOrUpdateCustomPortfolio();
  request.id = params.id;
  request.customPortfolio = params.customPortfolio;

  const response = await client.post(request);
  return response;
};

export const createClientProposalsV2 = async (params) => {
  const response = await client.postToUrl(
    "/v2/client/proposals/create/",
    params
  );
  return response;
};

export const getProjections = async (params) => {
  let request = params; /* new GetProjection();
  request.adjustForInflation = params
  // risk profile
  request.riskProfile = params.riskProfile;

  // income
  request.incomeCashFlowRequest = params.incomeCashFlowRequest;
  request.contributionCashFlowRequest = params.contributionCashFlowRequest;

  request.incomeCashFlowResponse = new GetIncomeCashFlowResponse({
    incomes: params.incomeCashFlowResponse.incomes,
  });
  request.contributionCashFlowResponse = new GetContributionCashFlowResponse({
    incomes: params.contributionCashFlowResponse.incomes,
  });
  // goal
  request.goalInfo = params.goalInfo;

  // fees
  request.platformFee = params.platformFee;
  request.advisorFee = params.advisorFee;
  request.otherCharges = params.otherCharges;

  // accounts
  request.accounts = params.accounts;
  request.currentAge = params.currentAge;
  request.incomeToLastUntilAge = params.incomeToLastUntilAge;
  console.log("getProjections", request);*/
  console.log("getProjections", request.managementFees, "fees");
  const response = await client.post(request);
  return response;
};

export const saveProjection = async (params) => {
  let request = new SaveProjection();
  request.clientGoalV2Id = params.clientGoalV2Id;
  request.clientId = params.clientId;
  request.requestObject = params.requestObject;
  request.responseObject = params.responseObject;

  const response = await client.post(request);
  return response;
};

export const getSavedProjection = async (params) => {
  const response = await client.get("/projections/get", params);
  return response;
};

export const deleteClientV2 = async (params) => {
  const response = await client.get("/v2/clients/delete/", params);
  return response;
};

export const deleteClientGoalsV2 = async (params) => {
  const response = await client.get("/v2/client/goals/delete/", params);
  return response;
};

export const getClientGoalsV2 = async (params) => {
  const response = await client.get("/v2/client/goals/", params);
  return response;
};

export const createProposalsV2 = async (params) => {
  const response = await client.get("/v2/client/proposals/create", params);
  return response;
};

export const getProposalsV2 = async (params) => {
  const response = await client.get("/v2/partner/proposals", params);
  return response;
};

export const getAuthenticatedClientProposal = async (params) => {
  const response = await client.get("/v2/auth/client/proposals", params);
  return response;
};

export const getClientsV2 = async (params) => {
  const response = await client.get("/v2/clients", params);
  return response;
};

export const getUsers = async (params) => {
  const response = await client.get("/users", params);
  return response;
};

export const getClientV2 = async (params) => {
  const response = await client.get("/v2/clients/" + params.id, params);
  return response;
};

export const updatePartnerCapitalMarketAssumptions = async (params) => {
  const response = await client.postToUrl("/projections/capm/update", params);
  return response;
};

export const getAccountsV2 = async (params) => {
  const response = await client.get("/v2/accounts/", params);
  return response;
};

export const getMdd = async (params) => {
  const response = await client.get("/mdd", params);
  return response;
};

export const getGoalTypes = async (params) => {
  const response = await client.get("/goals/types", params);
  return response;
};

export const getProjectionStats = async (params) => {
  const response = await client.get("/projections/stats", params);
  return response;
};

export const updateProposalStatusV2 = async (params) => {
  const response = await client.get(
    "/v2/client/proposals/updatestatus",
    params
  );
  return response;
};

export const deleteProposalsV2 = async (params) => {
  const response = await client.get("/v2/client/proposals/delete", params);
  return response;
};

// risk profiles
export const getRiskNeed = async (params) => {
  let request = new GetRiskNeed();
  request.Currency = params.currency;
  request.GetIncomeCashFlowRequest = params.getIncomeCashFlowRequest;
  request.GetContributionCashFlowRequest =
    params.getContributionCashFlowRequest;
  request.lumpSum = params.lumpSum;
  request.GoalInfo = params.goalInfo;
  if (params.additionalGetIncomeCashFlowRequests)
    request.AdditionalGetIncomeCashFlowRequests =
      params.additionalGetIncomeCashFlowRequests;
  if (params.additionalGetContributionCashFlowRequests)
    request.AdditionalGetContributionCashFlowRequests =
      params.additionalGetContributionCashFlowRequests;
  const response = await client.post(request);
  return response;
};

export const getRiskTolerance = async (params) => {
  const response = await client.get(
    "/riskprofiles/calculate/risktolerance",
    params
  );
  return response;
};

// risk profiles
export const getRiskAbility = async (params) => {
  let request = new GetRiskAbility();

  request.Currency = params.currency;
  request.GetIncomeCashFlowRequest = params.getIncomeCashFlowRequest;
  request.GetContributionCashFlowRequest =
    params.getContributionCashFlowRequest;
  request.lumpSum = params.lumpSum;
  request.goal = params.goal;
  request.override = params.override;
  request.overrideMessage = params.overrideMessage;
  request.overrideRiskProfileId = params.overrideRiskProfileId;

  request.liquidityNeeds = params.liquidityNeeds;
  request.goalTimeHorizon = params.goalTimeHorizon;
  request.riskCapacity = params.riskCapacity;
  const response = await client.post(request);
  return response;
};

export const getGoalRiskProfile = async (params) => {
  let request = new GetGoalRiskProfile();

  request.GetRiskAbilityResponse = params.getRiskAbilityResponse;
  request.GetRiskToleranceResponse = params.getRiskToleranceResponse;

  request.GetRiskNeedResponse = params.getRiskNeedResponse;

  request.Currency = params.currency;
  const response = await client.post(request);
  return response;
};

export const sendErrorEmail = async (params) => {
  const response = await client.get("/mail/template/quickerror", params);
  return response;
};

export const createUser = async (params) => {
  let request = new CreateUser();
  request.appName = params.appName;
  request.userName = params.userName;
  request.email = params.email;
  request.firstName = params.firstName;
  request.lastName = params.lastName;
  const response = await client.post(request);
  return response;
};

export const deleteUser = async (params) => {
  let request = new DeleteUser();
  request.email = params.email;
  const response = await client.post(request);
  return response;
};
